export default {
    numberRegex: new RegExp(/^[0-9]*[.]?[0-9]*$/),
    intRegex: new RegExp(/^[0-9]*$/),
    fiatRegex: new RegExp(/^[0-9]*[.]?[0-9]{0,2}$/),
    dentRegex: new RegExp(/^[0-9]*[.]?[0-9]{0,4}$/),
    phoneNumberRegex: new RegExp(/^\+[0-9]{8,20}$/),
    emailRegex: new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
    positiveNumberRegex: new RegExp(/^[1-9][0-9]*$/)
};
